// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"de2748f2","686":"2a1b6404","702":"a23f7f09"}[chunkId] + ".chunk.css";
};